import { render } from "./GoToLink.vue?vue&type=template&id=be0ad4dc"
import script from "./GoToLink.vue?vue&type=script&lang=js"
export * from "./GoToLink.vue?vue&type=script&lang=js"

import exportComponent from "/home/alejo/Development/AT/Apps/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__